/**
 * User-facing copy for Course Analysis empty and error states.
 * Keeps technical details (API, HTTP, backend) out of the UI.
 */

export const COURSE_ANALYSIS_MESSAGES = {
  NO_COURSE: 'Open a course to view its analysis.',
  TITLE_UNAVAILABLE: 'Analysis unavailable',
  EMPTY_DATA: "We couldn't load analysis for this course right now. Please try again in a moment.",
  REGENERATE_FAILED: "We couldn't refresh the analysis. Your last report is still shown.",
  EXPORT_COMING_SOON: 'Export coming soon',
  EXPORT_PREVIEW_HINT: "You'll be able to download and share reports here soon. Preview your selections below.",
  QUESTION_DETAIL_EMPTY: "Question details aren't available right now.",
};

/**
 * Map a fetch error to a friendly message without exposing infrastructure details.
 */
export function getCourseAnalysisFetchErrorMessage(err) {
  if (!err) {
    return COURSE_ANALYSIS_MESSAGES.EMPTY_DATA;
  }

  if (err.code === 'ERR_NETWORK' || !err.response) {
    return "We couldn't reach the server. Check your connection and try again.";
  }

  const status = err.response.status;

  if (status === 401 || status === 403) {
    return "We couldn't authenticate with the instructor API. Sign out, sign in again, and confirm your local .env credentials match the backend.";
  }

  if (status === 404) {
    return "Analysis isn't available for this course yet. Try again after learners submit graded work, or restart the local backend if other course pages work.";
  }

  if (status >= 500) {
    return 'Something went wrong on our end. Please try again in a moment.';
  }

  return COURSE_ANALYSIS_MESSAGES.EMPTY_DATA;
}
